import { axios } from '@/utils/request'

export default{
  createReply(input){
    return axios.post('/api/services/app/WxReply/CreateReply',input)
  },
  delete(id){
    return axios.delete('/api/services/app/WxReply/Delete?Id='+id)
  },
  getKeywordReply(input){
    return axios.get('/api/services/app/WxReply/GetKeywordReply',{params:input})
  },
  getSubscribe(){
    return axios.get('/api/services/app/WxReply/GetSubscribe')
  },
  update(input){
    return axios.put('/api/services/app/WxReply/Update',input)
  }
}